import React, { useState } from "react";
import { Form, Row, Col, Offcanvas } from "react-bootstrap";
import RespIm from "./RespIm";
import "../css/botones.css";
function ForgotPassword(props) {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState({ show: false, message: "" });
  const handleClose = () => setShow({ show: false, message: "" });
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    }
  };
  return (
    <div
      style={{
        alignContent: "center",
        paddingLeft: "1%",
        paddingRight: "1%",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <RespIm
          x0={1003}
          y0={700}
          x={300}
          src={require("../images/Logo.png").default}
        />
      </div>
      <div>
        <Offcanvas show={show.show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Posturalmente</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>{show.message}</Offcanvas.Body>
        </Offcanvas>
      </div>

      <div>
        <Row
          fluid
          className="justify-content-center"
          style={{ margin: "auto" }}
        >
          <Col Col xs={12} xl={8}>
            <p>
              {" "}
              Por favor ingrese su dirección de correo electrónico. Se le
              enviará un link para recuperar su contraseña.
            </p>
          </Col>
        </Row>
        <Row
          fluid
          className="justify-content-center"
          style={{ margin: "auto" }}
        >
          <Col Col xs={12} xl={8}>
            <Form
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
              id="Forma"
            >
              <Form.Group className="mb-3" controlId="userName">
                <Form.Label> Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Ingrese su email"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor ingrese su email
                </Form.Control.Feedback>
                <Form.Text className="text-muted"></Form.Text>
              </Form.Group>
            </Form>
          </Col>
        </Row>

        <Row
          fluid
          className="justify-content-center"
          style={{ paddingTop: "20px", margin: "auto" }}
        >
          <Col xs={6} xl={3} className="text-center">
            <button class="botones2" onClick={() => recuperarClave(props)}>
              Enviar
            </button>
          </Col>
          <Col Col xs={6} xl={3} className="text-center">
            {"   "}
            <button class="botones2" onClick={() => props.setEstado({ n: 0 })}>
              Volver
            </button>
          </Col>
        </Row>
        <Row
          fluid
          className="justify-content-center"
          style={{ paddingTop: "60px", margin: "auto" }}
        >
          <Col xs={12} xl={12} className="text-center"></Col>
        </Row>
      </div>
    </div>
  );
  function recuperarClave(props) {
    const form = document.getElementById("Forma");
    if (form.checkValidity() === true) {
      let mail = document.getElementById("userName").value;

      recoverPass(mail)
        .then((json) => {
          if (json.status === 200) {
            setShow({
              show: true,
              message:
                "El mail de recuperación de contraseña fue enviado con éxito. Por favor revise su casilla de correo y siga los pasos para hacerlo.",
            });
            //props.setEstado({ n: 10, nombre: json.data.nombre, url: "" });
          } else {
            setShow({ show: true, message: json.message });
          }
        })
        .catch((error) => alert(error));
    } else {
      setValidated(true);
    }
  }
  async function recoverPass(mail) {
    const res = await fetch(
      "https://entrenamientopostural.com/services/PHP/recoverPassword.php",
      {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },

        body: JSON.stringify({
          email: mail,
        }),
      }
    );
    if (res.status === 200) {
      const json = await res.json();
      return json;
    } else {
      return { status: res.status, message: "error" };
    }
  }
}
export default ForgotPassword;
